import './App.css'
import UserTypes from './UserTypes.jsx'
import {routesOper} from './routes/oper/routesOper.jsx'
import {routesWp} from './routes/wp/routesWp.jsx'
import {routesReporter} from './routes/reporter/routesReporter.jsx'

import AuthorizedApp from './components/common/authirization/AuthorizedApp.jsx'
import {useKeycloak} from '@react-keycloak/web'
import ModalKomunikatPowitalny from './components/views/komunikaty/ModalKomunikatPowitalny.jsx'

import {BrowserRouter as Router} from 'react-router-dom'
import {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {setUser} from './redux/user.js'

import 'react-toastify/dist/ReactToastify.css'
import Loader from './components/common/Loader.jsx'
import {useUprawnienia} from './api/domain/osoby/queries/useUprawnienia.jsx'
import {Top} from './components/common/index.js'
import Footer from './components/common/Footer.jsx'

const knownUserTypes = ['/wp', '/oper', '/reporter']

const userTypes = [
    {
        name: '/wp',
        routes: routesWp,
    },
    {
        name: '/oper',
        routes: routesOper,
    },
    {
        name: '/reporter',
        routes: routesReporter,
    },
]

function App() {
    const dispatch = useDispatch()
    const {keycloak, initialized} = useKeycloak()
    // const currUserType = keycloak?.tokenParsed?.user_types?.[0]
    const currUserType =
        knownUserTypes.find((t) =>
            keycloak?.tokenParsed?.user_types?.includes(t)) ?? '/wp'

    useEffect(() => {
        if (keycloak.authenticated && currUserType && initialized) {
            dispatch(
                setUser({
                    role: currUserType?.slice(1),
                })
            )
        }
    }, [currUserType, dispatch, keycloak.authenticated, initialized])

    const userPerms = useUprawnienia(!!keycloak.authenticated, keycloak.tokenParsed?.sub)

    useEffect(() => {
        if (userPerms?.data && keycloak.authenticated && currUserType) {
            dispatch(
                setUser({
                    ...(keycloak.tokenParsed || {}),
                    ...(userPerms?.data || {}),
                    permissions: userPerms.data?.perms || {},
                    role: currUserType?.slice(1),
                    profilId: userPerms.data?.profil_id,
                })
            )
        }
    }, [userPerms?.data, dispatch, keycloak.authenticated, keycloak.tokenParsed, currUserType])

    if (!initialized) {
        return <Loader/>
    }

    if (!keycloak.authenticated) {
        return <Loader/>
    }

    const currentUserTypeConfig =
        userTypes.find((u) => u.name === currUserType) || userTypes.find((u) => u.name === '/wp')
    let kcRoles = keycloak?.tokenParsed?.user_types?.length ? keycloak?.tokenParsed?.user_types : ['/wp']

    const hasRequiredRole = kcRoles.includes(currentUserTypeConfig.name)

    const isKnownUserType = knownUserTypes.some((t) =>
        keycloak?.tokenParsed?.user_types?.includes(t)) ? currUserType : '/wp'

    if (keycloak.authenticated && !isKnownUserType) {
        return (
            <div className="p-4">
                <h4>
                    Nie masz uprawnień do korzystania z aplikacji. Twoje konto
                    nie zostało poprawnie skonfigurowane. Skontaktuj się z
                    administratorem.
                </h4>
            </div>
        )
    }

    return (
        <>
            <Router>
                {hasRequiredRole ? (
                    <AuthorizedApp roles={[currentUserTypeConfig.name]}>
                        <Top type={currentUserTypeConfig.name.slice(1)}/>
                        <UserTypes
                            type={currentUserTypeConfig.name}
                            current={currUserType}
                            routes={currentUserTypeConfig.routes}
                        />
                    </AuthorizedApp>
                ) : (
                    <div>Nie masz dostępu do tego zasobu</div>
                )}
                <ModalKomunikatPowitalny/>
                <Loader/>
                <Footer/>
                {/*<pre*/}
                {/*    style={{*/}
                {/*        backgroundColor: '#f5f5f5',*/}
                {/*        padding: '10px',*/}
                {/*        borderRadius: '4px',*/}
                {/*        fontSize: '12px',*/}
                {/*        overflow: 'auto',*/}
                {/*        textAlign: 'left',*/}
                {/*    }}*/}
                {/*>*/}
                {/*    {JSON.stringify(keycloak.tokenParsed, null, 2)}*/}
                {/*</pre>*/}
            </Router>
        </>
    )
}

export default App
